<mat-icon
  role="img"
  inline
  [matTooltip]="tooltip()"
  [attr.aria-label]="tooltip()"
>
  lock
</mat-icon>
